<ng-container *ngrxLet="vm$ as vm">
  <nav
    class="header"
    aria-label="main navigation"
    data-analytics-nav="shelf-menu">
    <div class="header-container">
      <div class="top-section">
        <ng-container *ngFor="let navLinkGroup of navLinkGroups">
          <button
            class="parent-link bypass-block-target focus-link"
            tabindex="2"
            [class.active-link]="
              isActiveNavLinkGroup(navLinkGroup, vm.selectedNavLinkGroup)
            "
            [attr.aria-expanded]="
              isActiveNavLinkGroup(navLinkGroup, vm.selectedNavLinkGroup)
            "
            (click)="setSelectedNavLinkGroup(navLinkGroup)">
            <span>{{ navLinkGroup.name | translate }}</span>
          </button>

          <ul class="child-section">
            <li class="header-branding">
              <a
                class="bank-logo-link focus-link"
                [routerLink]="['/']"
                tabindex="1">
                <img
                  alt="My Offers Hub homepage"
                  class="header-logo"
                  [ngClass]="getBrandLogoName()"
                  [src]="logoImageUrl()" />
              </a>
            </li>

            <li>
              <hr class="logo-divider" />
            </li>

            <ng-container
              *ngFor="
                let navLink of vm.selectedNavLinkGroup.links;
                let i = index
              ">
              <li
                class="child-link"
                [ngClass]="i === 0 ? 'first-menu-item' : ''">
                <a
                  class="focus-link"
                  *ngIf="isExternalNavLink(navLink); else internalNavLink"
                  [href]="navLink.url"
                  tabindex="3">
                  {{ navLink.name | translate }}
                </a>
                <ng-template #internalNavLink>
                  <a
                    class="focus-link"
                    [routerLink]="[navLink.url]"
                    [class.active-child-link]="isActiveNavLink(navLink)"
                    >{{ navLink.name | translate }}</a
                  >
                </ng-template>
              </li>
            </ng-container>
          </ul>
        </ng-container>
      </div>
    </div>
  </nav>
</ng-container>

<rd-westpac-mobile-header></rd-westpac-mobile-header>
